<div class="custom-price-container" [ngClass]="{'custom-price-container--loading': loading}">
  <span *ngIf="knownPrice; else unknownPrice">
    <span class="bold offer-price-part font-26">{{ price | offerMainPrice | separator}},</span>
    <span class="bold offer-price-part font-20">{{ price | offerTailsPrice}}</span>
  </span>
  <ng-template #unknownPrice>
    <span *ngIf="!loading" class="bold offer-price-part font-26">- - - -,</span>
    <span *ngIf="!loading" class="bold offer-price-part font-20">- -</span>
    <span *ngIf="loading" class="loader"></span>
  </ng-template>
  <span class="bold offer-price-part font-20">&nbsp;{{'OFFER_SECTION.SHARED.currencyShortcut' | translate}}</span>
</div>
